import script from "./signup.vue?vue&type=script&setup=true&lang=js"
export * from "./signup.vue?vue&type=script&setup=true&lang=js"

import "./signup.vue?vue&type=style&index=0&id=546fb344&lang=css"

const __exports__ = script;

export default __exports__